import React, { useState } from 'react';

import styles from './InputAddressAutocomplete.module.css';

interface Props {
    defaultLabel?: string
    label: React.ReactNode
    error?: boolean
    showOptions: boolean,
    onChange: React.ChangeEventHandler<HTMLInputElement>
    onClick: (e?: React.MouseEvent) => void
}

const InputAddressAutocomplete: React.FC<Props> = ({
    defaultLabel,
    label,
    error,
    showOptions,
    onChange,
    onClick
}) => {

    const [inputValue, setInputValue] = useState<string>(
        typeof label === 'string' ? label : defaultLabel ?? ''
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);
        onChange(e);
        const show = value.trim().length > 0;
        if (show !== showOptions && !label) onClick();
    };

    return (
        <input
            type='text'
            className={`${styles.inputAutocomplete} ${error ? styles.error : ''}`}
            onChange={handleChange}
            value={inputValue}
        />
    );
};

export default InputAddressAutocomplete;